import { createStyles, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import EskassaLogo from '../../assets/eskassa.svg';

const styles = createStyles(theme => ({
  root: {
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.light,
    boxShadow: theme.shadows[4],
  },
}));

const CommonLogo = React.forwardRef((props, ref) => {
  const { classes, className, style } = props;
  return (
    <img
      ref={ref}
      style={style}
      className={classNames(
        classes.root,
        className,
      )}
      src={EskassaLogo}
      alt="Eskassa logo"
    />
  );
});

export default withStyles(styles, { name: 'CommonLogo' })(CommonLogo);
